"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeItemsCapabilities = void 0;
const ChangeItemCreateLogCapabilities = {
    CanCreateCCD: "can_create_ccd",
    CanCreateCP: "can_create_cp",
    CanCreatePR: "can_create_pr",
    CanCreateSI: "can_create_si",
    CanLogCCD: "can_log_ccd",
    CanLogCP: "can_log_cp",
    CanLogPR: "can_log_pr",
    CanLogSI: "can_log_si",
};
exports.ChangeItemsCapabilities = Object.assign(Object.assign({}, ChangeItemCreateLogCapabilities), { CanExport: "can_export", CanViewSettings: "can_view_settings" });
//# sourceMappingURL=ChangeItemsCapabilities.js.map